/**
 * Returns the icon name based on the file extension.
 */
export function getIconNameByFile(fileName: string) {
  const extension = fileName.split('.').slice(-1).join('');

  switch (extension) {
    case 'har':
    case 'js':
    case 'json':
      return 'file-js';
    case 'css':
    case 'sass':
    case 'scss':
      return 'file-css';
    case 'pdf':
      return 'file-pdf';
    case 'html':
    case 'xml':
      return 'file-html';
    case 'md':
    case 'mdx':
    case 'txt':
      return 'file-text';
    default:
      return 'file';
  }
}
